import React from 'react'
import NavItems from './NavItems'

function NavBar() {
  return (
    <div className='navbar'>
      
      <NavItems></NavItems>

    </div>
  )
}

export default NavBar
